import { mergeClasses } from "@fluentui/react-components";
import AmdNumberInput from "./AmdNumberInput";

export interface IAmdTimeInputProps {
  className?: string;
  label?: string;
  hours: number;
  setHours: (value: number) => void;
  mins: number;
  setMins: (value: number) => void;
  padHour?: boolean;
  padMinute?: boolean;
}

export default function AmdTimeInput({
  className = "",
  label = "",
  hours,
  setHours,
  mins,
  setMins,
  padHour = false,
  padMinute = false,
}: IAmdTimeInputProps) {
  return (
    <div
      className={mergeClasses(className, "d-flex amd-container-vcolumn")}
      data-testid="amd-time-input"
    >
      <span className="fw-500 pb-sm-1">{label}</span>
      <div className="amd-container-vcenter">
        <AmdNumberInput
          value={hours}
          setValue={setHours}
          maxValue={23}
          padValue={padHour}
        />
        <span className="px-1">:</span>
        <AmdNumberInput
          value={mins}
          setValue={setMins}
          maxValue={59}
          padValue={padMinute}
        />
      </div>
    </div>
  );
}
